import { render, staticRenderFns } from "./EntityFilterCatalogs.vue?vue&type=template&id=afcb36c6"
import script from "./EntityFilterCatalogs.vue?vue&type=script&lang=js"
export * from "./EntityFilterCatalogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports